<template>
  <v-container fluid>
  <v-dialog v-model="custfilterdialog" max-width="590">
    <Customerfilters v-on:hideCustFilters="hideCustFilters()" />
  </v-dialog>
  <v-dialog v-model="quotationDialog"  persistent max-width="800px">
    <v-card>
      <v-card-title>
        <span class="text-h5">{{ formTitle }}</span>
      </v-card-title>
      <template v-slot:prepend-item>
      <v-list-item>
        <v-list-item-content>
          <v-text-field v-model="custsearch" placeholder="Search" @input="searchCustomers" append-icon="mdi-search"></v-text-field>
        </v-list-item-content>
      </v-list-item>
      <v-divider class="mt-2"></v-divider>
    </template>    
    <v-container fluid>
      <v-row class="d-flex" dense>
        <v-col cols="10" class="d-flex align-center">
          <v-autocomplete v-model="selectedCustomer" 
                    :items="allcustomers"  
                    item-value="PARTYMST_DOCNO"
                    item-text="PARTYMST_DESC"
                    label="Customer Name" 
                    solo>
            <template v-slot:prepend-item>
              <v-list-item>
                <v-list-item-content>
                  <v-text-field v-model="custsearch" placeholder="Search for Customers" @input="searchCustomers" append-icon="mdi-search"></v-text-field>
                </v-list-item-content>
              </v-list-item>
              <v-divider class="mt-2"></v-divider>
            </template>
          </v-autocomplete>
        </v-col>
        <v-col cols="2" class="d-flex justify-center">
          <v-btn color="primary" @click="showCustFilters" icon fab>
            <v-icon>
              mdi-filter
            </v-icon>
          </v-btn>
        </v-col>
      </v-row>      
    </v-container>

    <v-card-text>
      <v-container>
        <v-row>
          <v-col cols="12" sm="6" md="4">
            <v-text-field
              v-model="editedItem.SAL_SUBLEDGER_DOCNO"
              label="Customer Code"
            ></v-text-field>
          </v-col>
          <v-col cols="12" sm="6" md="4">
            <v-text-field
              v-model="editedItem.PARTYMST_DESC"
              label="Customer Name"
            ></v-text-field>
          </v-col>
          <v-col cols="12" sm="6" md="4" >
            <v-text-field
              v-model="editedItem.SAL_NET_AMOUNT"
              label="Net Amt"
            ></v-text-field>
          </v-col>
          <v-col cols="12" sm="6" md="4">
            <v-text-field
              v-model="editedItem.SAL_DOCNO"
              label="SAL_DOCNO"
            ></v-text-field>
          </v-col>
          <v-col cols="12" sm="6" md="4">
            <v-text-field
              v-model="editedItem.SAL_CREATED_BY"
              label="Created By"
            ></v-text-field>
          </v-col>
        </v-row>
      </v-container>
    </v-card-text>

    <v-card-actions>
      <v-spacer></v-spacer>
      <v-btn color="blue darken-1" text @click="close">
        Cancel
      </v-btn>
      <v-btn color="blue darken-1" text @click="save">
        Save
      </v-btn>
    </v-card-actions>
    </v-card>
  </v-dialog>
  <!-- delete confirmation -->
  <v-dialog v-model="dialogDelete" max-width="500px">
    <v-card>
      <v-card-title class="text-h5">Are you sure you want to delete this item?</v-card-title>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn color="blue darken-1" text @click="closeDelete">Cancel</v-btn>
        <v-btn color="blue darken-1" text @click="viewItemConfirm">OK</v-btn>
        <v-spacer></v-spacer>
      </v-card-actions>
    </v-card>
  </v-dialog>
  <!-- quoatationlist -->
  <v-data-table
    :headers="headers"
    :items="allsalesorders"
    sort-by="Date"
    class="elevation-1"
    >
    <template v-slot:top>
      <v-toolbar>
        <v-select
          v-model="selectedsalesman"
          :items="salespersons"         
          item-value="SMAN_DOCNO"
          item-text="SMAN_DESC"
          label="Sales-persons"          
          @change="getallSQ"
          clearable
          class="mt-3"
        />
        <v-divider class="mx-4 ml-5 mr-5" inset vertical></v-divider>
        <v-btn class="mt-1" fab icon small color="primary"
          @click="getallSQ();getAllcustomers();" >
          <v-icon dark>
            mdi-refresh
          </v-icon>
        </v-btn>
        <v-spacer></v-spacer>
        <v-btn color="primary" dark class="mb-2" @click="quotationDialog=true">
          New Quotation
        </v-btn>
      </v-toolbar>
    </template>
    <template v-slot:item.date="{ item }">
      {{date(item)}}    
    </template>
    <template v-slot:item.actions="{ item }">
      <v-icon small class="mr-2" @click="editItem(item)">
        mdi-pencil
      </v-icon>
      <v-icon small @click="viewItem(item)">
        mdi-eye
      </v-icon>
    </template>
    <template v-slot:no-data>
      <v-btn color="primary" @click="initialize">
        Reset
      </v-btn>
    </template>
  </v-data-table>
</v-container> 
</template>

<!-- <v-btn color="primary" @click="showDialog = true">Newwer Quotation</v-btn>
      <v-dialog v-model="showDialog" max-width="800">
        <v-card>
          <v-card-title>
            <span class="headline">{{ dialogTitle }}</span>
          </v-card-title>
          <v-card-text>
            <NewQuotation @close="showDialog = false" />
          </v-card-text>
        </v-card>
      </v-dialog> -->
  
      <!-- <OrderWizard/> -->
<script>
import moment from "moment";
// import NewQuotation from "@/components/NewQuotation.vue";
import Customerfilters from "@/components/Customerfilters";
// import OrderWizard from "@/components/OrderWizard";
  export default {
    components: {
      Customerfilters,
      // OrderWizard,
      // NewQuotation,
    },
    data: () => ({
      quotationDialog: false,
      showDialog: false,
      dialogDelete: false,
      sodoctype: 'SQ',
      custfilterdialog: false,
      selectedsalesman:'', 
      headers: [     
        { text: 'Date', value: 'date' },
        { text: 'Party Code', value: 'SAL_SUBLEDGER_DOCNO' },
        { text: 'Party Name', value: 'PARTYMST_DESC' },
        { text: 'Net Amt', value: 'SAL_NET_AMOUNT' },
        { text: 'Created by', value: 'SAL_CREATED_BY' },
        { text: 'Status', value: 'SAL_DOCUMENT_STATUS_DOCNO' },
        { text: 'Actions', value: 'actions', sortable: false },
      ],

      editedItem: {
        name: '',
        calories: 0,
        fat: 0,
        carbs: 0,
        protein: 0,
      },
      
      custsearch: "",
      selectedCustomer: "",
      customers: [],
      selecteditems: []
    }),

    computed: {
      formTitle () {
        return this.editedIndex === -1 ? 'New Quotation ' : 'Edit Quotation'
      },
      dialogTitle() {
        switch (this.currentStep) {
          case 1:
            return "New Quotation: Customer Info";
          case 2:
            return "New Quotation: Product Info";
          case 3:
            return "New Quotation: Order Info";
          default:
            return "New Quotation";
        }
      },
      // facts 
      usersperson() {
      if (this.$store.getters.factsuser.USER_DEFAULT_SMAN_DOCNO) {
          return this.$store.getters.factsuser.USER_DEFAULT_SMAN_DOCNO;
        } else {
          return "";
        }
      },
      person(){
        if (this.usersperson != "")
        return this.usersperson
        else
        return ""
      },
      salespersons() {
        return this.$store.getters.salespersons;
      },
      salesperson() {
        return this.$store.getters.salesperson;
      },
      sman() {
        if (this.selectedsalesman) {
          return this.selectedsalesman;
        } else {
          return this.usersperson;
        }
      },
      allcustomers(){
        return this.$store.getters.allcustomers;
      },
      allsalesorders(){      
        return this.$store.getters.allsalesorders;
      },
      salesordersdetails(){      
        return this.$store.getters.salesordersdetails;
        // .map(salesordersdetail => ({...salesordersdetails, subtotal: item.SALDET_QTY*item.SALDET_RATE}) )
      },  
      selectedcust() {
        return this.$store.getters.thiscustomer;
      },
      customersdatalist() {
        return this.$store.getters.customersdata;
      },
      customersproductslist() {
        return this.$store.getters.customerproducts;
      },
      contacts() {
        return this.$store.getters.allcontacts;
      },   
      itemDisplay(){
        if (this.salesordersdetails.length() > 0){
          return true
        }else{
          return false
        }
      }
    },

    watch: {
      dialog (val) {
        val || this.close()
      },
      dialogDelete (val) {
        val || this.closeDelete()
      },
    },
    methods: {      
      initialize () {
       
      },

      editItem (item) {
        // this.editedIndex = this.desserts.indexOf(item)
        this.editedItem = Object.assign({}, item)
        this.quotationDialog = true
      },

      viewItem (item) {
        this.editedIndex = this.desserts.indexOf(item)
        this.editedItem = Object.assign({}, item)
        this.dialogDelete = true
      },

      viewItemConfirm () {
        this.desserts.splice(this.editedIndex, 1)
        this.closeDelete()
      },

      close () {
        this.quotationDialog = false
        this.$nextTick(() => {
          this.editedItem = Object.assign({}, this.defaultItem)
          this.editedIndex = -1
        })
      },

      closeDelete () {
        this.dialogDelete = false
        this.$nextTick(() => {
          this.editedItem = Object.assign({}, this.defaultItem)
          this.editedIndex = -1
        })
      },

      save () {
        if (this.editedIndex > -1) {
          // Object.assign(this.desserts[this.editedIndex], this.editedItem)
        } else {
          // this.desserts.push(this.editedItem)
        }
        this.close()
      },
      showCustFilters() {
        this.custfilterdialog = true;
      },
      hideCustFilters() {
        this.custfilterdialog = false;
      },
      //get a customer
      getCustomersData() {
        this.$store.dispatch("getCustomersData", {
          smandocno: this.$store.getters.salesperson,
          search: "",
          doctype: "",
          docno: "",
          blockstat: "",
          lastinv: "",
          oldinv: "",
          skip: 0,
          sortby: "",
          sortord: "",
        });                                  
      },
      // getall customers      
      getAllcustomers(){
        this.$store.dispatch("getAllCustomers", {
          search: this.custsearch,
          smandocno: this.sman,
          skip: 0,
          limit: 50,
        });        
        // this.$store.dispatch("getAllCustomers",{smandocno: this.sman });
      },
      // search
      searchCustomers() {
      if (!this.custsearch) {
      this.allcustomers = this.customers;
        }
        this.allcustomers = this.customers.filter((customer) => {
          return customer.toLowerCase().indexOf(this.custsearch.toLowerCase()) > -1;
        });
      },     
      // connecting facts
      setSalesPerson() {
        this.$store.dispatch("getSalesPerson", { smandocno: this.sman });
      },
      getallSQ() {
        this.setSalesPerson();
        this.$store.dispatch("getallsalesorders", { smandocno: this.sman,sodoctype:this.sodoctype });
      },
      date(item){     
        return(moment(item.SAL_DOCDATE).format('DD-MM-YYYY'))
      },
    },
    created() {
    // this.initialize()
    // this.getAllcustomers()
    // this.getCustomersData();
    },
    mounted() {
    this.$store.dispatch("getLoading", true);
    this.customers = [...this.allcustomers];
    // this.setSalesPerson(this.usersperson);
    this.getallSQ();
    this.getAllcustomers()
    this.$store.dispatch("getLoading", false);
  }
  }
</script>